// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetBestEnrollmentV2RequestModel {
    static getAttributeTypeMap() {
        return GetBestEnrollmentV2RequestModel.attributeTypeMap;
    }
}
GetBestEnrollmentV2RequestModel.discriminator = undefined;
GetBestEnrollmentV2RequestModel.additionalProperties = false;
GetBestEnrollmentV2RequestModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "includeQueuedTransient",
        "baseName": "includeQueuedTransient",
        "type": "boolean"
    },
    {
        "name": "includeRejected",
        "baseName": "includeRejected",
        "type": "boolean"
    },
    {
        "name": "removeTestPatients",
        "baseName": "removeTestPatients",
        "type": "boolean"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
];
//# sourceMappingURL=getBestEnrollmentV2RequestModel.js.map